import { Button, Checkbox, Tabs } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import ApplicationsTab from './ApplicationsTab/ApplicationsTab';
import FiltersForm from '../../components/FiltersForm/FiltersForm';
import Icon from '../../components/Icon/Icon';
import SearchForm from '../../components/SearchForm/SearchForm';
import UsersTab from './UsersTab/UsersTab';

import useBackofficeUsers from './useBackofficeUsers';

import styles from './BackofficeUsers.module.scss';
import AdminsTab from './AdminsTab/AdminsTab';
import RatingsTab from './RatingsTab/RatingsTab';
import { useEffect } from "react";
import Popup from '../../components/Popup/Popup';
import RenewalTab from './RenewalTab/RenewalTab';

const BackofficeUsers = () => {
	const {
		state,
		getFiltersAsQueryParams,
		onChangeViewMentorsOnly,
		onChangeViewMyRatingsOnly,
		onClickTab,
		onExportUsers,
		onResetFilters,
		onSearchByTerm,
		onSubmitFilters,
		toggleExportPopup,
		toggleMobileFilters,
	} = useBackofficeUsers();
	const {
		activeFilters,
		activeKey,
		email,
		filterDefaultValues,
		filterFields,
		showExportPopup,
		showMobileFilters,
	} = state;

	const { TabPane } = Tabs;

	const location: any = useLocation();
	const { activeTab } = location.state || {};

	useEffect(() => {
		if (activeTab >= 2)
			onClickTab(activeTab.toString())
	}, [activeTab]);


	const tabBarExtraContent = {
		right: (
			<div className={styles.tabBarExtraContent}>
				{(activeKey === '1' || activeKey === '2') &&
					<Checkbox className={styles.checkbox} onChange={onChangeViewMentorsOnly}><FormattedMessage id="formLabels.viewMentors" /></Checkbox>}
				{activeKey === '1' && <Button type="primary" onClick={onExportUsers}>
					<FormattedMessage id='buttons.exportAllUsers' />
				</Button>}
				{activeKey === '4' &&
					<Checkbox className={styles.checkbox} onChange={onChangeViewMyRatingsOnly}><FormattedMessage id="formLabels.viewMyRatings" /></Checkbox>
				}
			</div>
		)
	};

	return (
		<div className={styles.pageContainer}>
			<div className={`${styles.pageSider} ${styles.topBorder}`}>
				{activeKey !== '4' && <SearchForm onSearchByTerm={onSearchByTerm} />}
				{activeKey !== '5' && activeKey !== '3' && (
					<FiltersForm
						activeForm={activeKey}
						fields={filterFields}
						defaultValues={filterDefaultValues}
						onResetFilters={onResetFilters}
						onSubmit={(filters) => onSubmitFilters(filters)}
					/>
				)}
			</div>

			<div className={styles.pageContent}>
				<>
					<div className={styles.mobileTopper}>
						{activeKey !== '4' && (
							<SearchForm onSearchByTerm={onSearchByTerm} />
						)}
						{activeKey !== '5' && activeKey !== '3' && (
							<Button
								type="text"
								onClick={toggleMobileFilters}
								icon={<Icon color="black" name="sliders-h" />}
							/>
						)}
					</div>
					{activeKey !== '5' &&
						<div className={styles.tabBarExtraContentMobile}>
							{(activeKey === '1' || activeKey === '2') && <Checkbox
								className={styles.checkbox}
								onChange={onChangeViewMentorsOnly}
							>
								<FormattedMessage id="formLabels.viewMentors" />
							</Checkbox>
							}
							{activeKey === '1' && <Button type="primary" onClick={onExportUsers}>
								<FormattedMessage id='buttons.exportAllUsers' />
							</Button>
							}
							{activeKey === '4' &&
								<Checkbox className={styles.checkbox} onChange={onChangeViewMyRatingsOnly}><FormattedMessage id="formLabels.viewMyRatings" /></Checkbox>
							}
						</div>
					}
				</>
				<Tabs
					className={`navigator ${styles.content}`}
					defaultActiveKey={activeTab?.toString() || '1'}
					onChange={onClickTab}
					tabBarExtraContent={activeKey !== '5' && tabBarExtraContent}
				>
					<TabPane
						tab={
							<>
								<span className={styles.tabNav}>
									<FormattedMessage id="navigation.users" />
								</span>
								<span className={styles.tabDivider}>/</span>
							</>
						}
						key="1"
					>
						<UsersTab filters={getFiltersAsQueryParams(activeFilters)} />
					</TabPane>
					<TabPane
						tab={
							<>
								<span className={styles.tabNav}>
									<FormattedMessage id="navigation.applications" />
								</span>
								<span className={styles.tabDivider}>/</span>
							</>
						}
						key="2"
					>
						<ApplicationsTab filters={getFiltersAsQueryParams(activeFilters)} />
					</TabPane>
					<TabPane
						tab={
							<>
								<span className={styles.tabNav}>
									<FormattedMessage id="navigation.renewal" />
								</span>
								<span className={styles.tabDivider}>/</span>
							</>
						}
						key="3"
					>
						<RenewalTab filters={getFiltersAsQueryParams(activeFilters)} />
					</TabPane>
					<TabPane
						tab={
							<>
								<span className={styles.tabNav}>
									<FormattedMessage id="navigation.ratings" />
								</span>
								<span className={styles.tabDivider}>/</span>
							</>
						}
						key="4"
					>
						<RatingsTab filters={getFiltersAsQueryParams(activeFilters)} />
					</TabPane>
					<TabPane
						tab={
							<>
								<span className={styles.tabNav}>
									<Icon
										className={styles.adminsIcon}
										name="users-crown"
										color={activeKey === '5' ? 'accent' : 'gray'}
										width="20px"
									/>
									<FormattedMessage id="navigation.admins" />
								</span>
							</>
						}
						key="5"
					>
						<AdminsTab filters={getFiltersAsQueryParams(activeFilters)} />
					</TabPane>
				</Tabs>
			</div>

			{/* Mobile filters */}
			<div
				className={`${styles.mobileFiltersBackdrop} ${showMobileFilters ? styles.open : ''
					}`}
			></div>
			<div
				className={`${styles.mobileFilters} ${showMobileFilters ? styles.open : ''
					}`}
			>
				<div className={styles.actions}>
					<Button
						onClick={toggleMobileFilters}
						type="link"
						style={{ paddingRight: 0 }}
					>
						<Icon color="text" height="16px" name="times" width="16px" />
					</Button>
				</div>
				<FiltersForm
					activeForm={activeKey}
					fields={filterFields}
					defaultValues={filterDefaultValues}
					onResetFilters={() => onResetFilters(toggleMobileFilters)}
					onSubmit={(filters) => onSubmitFilters(filters, toggleMobileFilters)}
				/>
			</div>

			{showExportPopup && (
				<Popup onClose={toggleExportPopup} size="small">
					<div className={styles.popupContent}>
						<Icon
							name="paper-plane"
							width="64px"
							height="64px"
							color="accent"
						/>
						<p>
							<FormattedMessage
								id="statistics.export.info"
								values={{ email }}
							/>
						</p>
					</div>
				</Popup>
			)}
		</div>
	);
};

export default BackofficeUsers;